import {
  BarcodeExportConfiguration,
  CreateBarcodeExportConfigurationInput,
  DeleteBarcodeExportConfigurationInput,
  UpdateBarcodeExportConfigurationInput,
} from '../types/barcode_export_configuration';
import { BarcodeExportEntityType } from '../types/barcode_export_configuration/barcodeExportConfiguration';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const EXPORT_URL = '/api/barcode/export';
const CREATE_URL = '/api/barcode/export/create';
const UPDATE_URL = '/api/barcode/export/update';
const DELETE_URL = '/api/barcode/export/delete';
const LIST_URL = '/api/barcode/export/list';

export namespace BarcodeExportConfigurationRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<BarcodeExportConfiguration>> => {
    return (await http.post(LIST_URL, payload)).data;
  };

  export interface CreatePayload {
    data: CreateBarcodeExportConfigurationInput[];
  }

  export async function create(payload: CreatePayload): Promise<BarcodeExportConfiguration[]> {
    const response = await http.post(CREATE_URL, payload);
    return response.data;
  }

  export interface UpdatePayload {
    data: UpdateBarcodeExportConfigurationInput[];
  }
  export async function update(payload: UpdatePayload): Promise<BarcodeExportConfiguration[]> {
    const response = await http.post(UPDATE_URL, payload);
    return response.data;
  }

  export interface DeletePayload {
    data: DeleteBarcodeExportConfigurationInput[];
  }
  export async function remove(payload: DeletePayload): Promise<BarcodeExportConfiguration[]> {
    const response = await http.post(DELETE_URL, payload);
    return response.data;
  }

  export interface GeneratePayload {
    entityType: BarcodeExportEntityType;
    entityIds: string[];
    configurationId: string;
  }
  export interface GenerateResponse {
    data: any; // TODO: Is a file
  }
  export async function generate(payload: GeneratePayload): Promise<any> {
    const response = await http.post(EXPORT_URL, payload);
    return response.data;
  }
}
